module.exports = __webpack_public_path__ + "static/media/envelope.9a2fc494.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/envelope.svg
// module id = 1953
// module chunks = 70